module.exports = __webpack_public_path__ + "img/store-logo.dd9ff5d7.png";